import Component from '../inherited/Component'
import Helpers from '../lib/Helpers'

export default class FaqQuestions extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._elems = this._elem.children
  }

  mount () {
    this._elem.addEventListener('click', e => {
      e.preventDefault()
      console.log(e)
      let question = e.target.textContent

      window.location = this._elem.href + `&question=${encodeURIComponent(question)}`


    })
    
  }
}